module.exports = __webpack_public_path__ + "41248af41bce233c8c57fa32e00f41a0.obj";